module.exports = __webpack_public_path__ + "static/media/speakers.d532f290.jpeg";